import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../shared/alert/alert.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ParamContext } from '../shared/service/param.context';
import { HelpService } from '../shared/service/help.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { UrlService } from '../shared/service/url.service';
import { HELP_SINGLE_SITE_ANALYSIS } from '../app.constants';
import { StudyManagerTreeComponent } from '../study-manager/study-manager-tree.component';
import { SingleSiteAnalysisContext } from './single-site-analysis.context';
import { StudyService } from '../shared/study/service/study.service';
import { StudyDetails } from '../shared/study/model/study-details.model';
import { DatasetModel } from '../shared/dataset/model/dataset.model';
import { DatasetService } from '../shared/dataset/service/dataset.service';
import { DatasetTypeEnum } from '../shared/dataset/model/dataset-type.enum';
import { ObservationVariable } from '../shared/model/observation-variable.model';
import { VariableTypeEnum } from '../shared/ontology/variable-type.enum';
import { DatePipe } from '@angular/common';
import { ObservationUnitsSearchResponse } from '../shared/dataset/model/observation-units-search-response.model';
import { ObservationUnitsSearchRequest } from '../shared/dataset/model/observation-units-search-request.model';
import { EnvironmentFactorModel } from './environment-factor.model';
import { ExperimentalDesignTypeEnum } from '../shared/experimental.design/experimental-design-type.enum';
import { TermIdEnum } from '../shared/ontology/model/termid.enum';
import { finalize } from 'rxjs/internal/operators/finalize';
import { FileDownloadHelper } from '../entities/sample/file-download.helper';
import { SingleSiteAnalysisService } from './single-site-analysis.service';
import { SingleSiteAnalysisInputModel } from './single-site-analysis-input.model';
import { SingleSiteAnalysisImportComponent } from './single-site-analysis-import.component';
import { DataTypeEnum } from '../shared/ontology/data-type.enum';
import { JhiEventManager, JhiLanguageService } from '../shared/core-utils';

@Component({
    selector: 'jhi-single-site-analysis',
    templateUrl: './single-site-analysis.component.html'
})
export class SingleSiteAnalysisComponent implements OnInit {

    ExperimentalDesignTypeEnum = ExperimentalDesignTypeEnum;

    TRIAL_INSTANCE = TermIdEnum.TRIAL_INSTANCE;

    helpLink: string;
    study: StudyDetails = null;
    plotDatasetName: string;
    projectType = 'Field Trial';
    plotDatasetId: number;
    environmentDataset: DatasetModel;
    environmentDatasetId: number;
    instanceNumberIdMap = {};
    plotDatasetVariables: ObservationVariable[] = [];
    germplasmDescriptors: ObservationVariable[] = [];
    traits: ObservationVariable[] = [];
    covariates: ObservationVariable[] = [];
    selectedTraits: any[] = [];
    selectedCovariates: any[] = [];
    selectedEnvironmentFactors: any[] = [];
    isLoading = false;
    isBrowseStudyScreen = true;
    analysisName: string;
    environmentVariables: ObservationVariable[] = [];
    selectedEnvironmentFactor: ObservationVariable;
    repFactors: ObservationVariable[] = [];
    selectedRepFactor: ObservationVariable;
    incompleteBlockFactors: ObservationVariable[] = [];
    selectedIncompleteBlockFactor: ObservationVariable;
    rowFactors: ObservationVariable[] = [];
    selectedRowFactor: ObservationVariable;
    colFactors: ObservationVariable[] = [];
    selectedColFactor: ObservationVariable;
    genotypeVariables: ObservationVariable[] = [];
    selectedGenotype: ObservationVariable;

    environmentFactors: EnvironmentFactorModel[] = [];
    invalidEnvironmentFactorIds: number[] = [];
    selectedExptDesignType: ExperimentalDesignTypeEnum;
    studyExptDesign: number;

    ExperimentalDesignTypeMap = new Map<number, ExperimentalDesignTypeEnum>();

    readonly exptDesignTypes = [ExperimentalDesignTypeEnum.RESOLVABLE_INCOMPLETE_BLOCK, ExperimentalDesignTypeEnum.RANDOMIZED_COMPLETE_BLOCK,
        ExperimentalDesignTypeEnum.ROW_COL, ExperimentalDesignTypeEnum.P_REP, ExperimentalDesignTypeEnum.AUGMENTED_RANDOMIZED_BLOCK];

    constructor(private route: ActivatedRoute,
                private eventManager: JhiEventManager,
                private languageService: JhiLanguageService,
                private alertService: AlertService,
                public activeModal: NgbActiveModal,
                private modalService: NgbModal,
                private paramContext: ParamContext,
                private helpService: HelpService,
                private studyService: StudyService,
                private datasetService: DatasetService,
                private context: SingleSiteAnalysisContext,
                private datePipe: DatePipe,
                private fileDownloadHelper: FileDownloadHelper,
                private singleSiteAnalysisService: SingleSiteAnalysisService,
                private router: Router,
                private urlService: UrlService) {
        this.paramContext.readParams();
    }

    ngOnInit() {
        if (!this.helpLink || !this.helpLink.length) {
            this.helpService.getHelpLink(HELP_SINGLE_SITE_ANALYSIS).toPromise().then((response) => {
                this.helpLink = response.body;
            }).catch((error) => {});
        }
        this.exptDesignTypes.forEach((experimentalDesignType) => this.ExperimentalDesignTypeMap.set(experimentalDesignType.termId, experimentalDesignType));
    }

    browseStudy($event) {
        $event.preventDefault();
        const studyTreeComponent = this.modalService.open(StudyManagerTreeComponent, { modalDialogClass: 'modal-md', backdrop: 'static' });
        studyTreeComponent.componentInstance.hideViewSummaryButton = true;
        studyTreeComponent.result.then((studies) => {
            if (studies && studies.length === 1) {
                this.loadStudy(studies[0]);
            }
            this.activeModal.close();
        }, () => {
        });
    }

    variableTrackId(index: number, item: ObservationVariable) {
        return item.termId;
    }

    environmentFactorTrackId(index: number, item: ObservationUnitsSearchResponse) {
        return item.observationUnitId;
    }

    isTraitSelected(variable: ObservationVariable) {
        return variable && this.selectedTraits.length > 0 && this.selectedTraits.find((item) => item === variable.termId);
    }

    isCovariatesSelected(variable: ObservationVariable) {
        return variable && this.selectedCovariates.length > 0 && this.selectedCovariates.find((item) => item === variable.termId);
    }

    toggleTraitSelect(variable: ObservationVariable) {
        if (this.selectedTraits.length > 0 && this.selectedTraits.find((item) => item === variable.termId)) {
            this.selectedTraits = this.selectedTraits.filter((item) => item !== variable.termId);
        } else {
            this.selectedTraits.push(variable.termId);
        }
    }

    toggleCovariateSelect(variable: ObservationVariable) {
        if (this.selectedCovariates.length > 0 && this.selectedCovariates.find((item) => item === variable.termId)) {
            this.selectedCovariates = this.selectedCovariates.filter((item) => item !== variable.termId);
            this.toggleTraitSelect(variable);
        } else {
            this.selectedCovariates.push(variable.termId);
        }
    }

    isEnvironmentFactorSelected(factor: EnvironmentFactorModel) {
        return factor && this.selectedEnvironmentFactors.length > 0 && this.selectedEnvironmentFactors.find((item) => item === factor.instanceId);
    }

    toggleEnvironmentFactorSelect(factor: EnvironmentFactorModel) {
        if (this.selectedEnvironmentFactors.length > 0 && this.selectedEnvironmentFactors.find((item) => item === factor.instanceId)) {
            this.selectedEnvironmentFactors = this.selectedEnvironmentFactors.filter((item) => item !== factor.instanceId);
        } else {
            this.selectedEnvironmentFactors.push(factor.instanceId);
        }
    }

    isAllEnvironmentFactorSelected() {
        return this.environmentFactors.length > 0 && this.environmentFactors.length === this.selectedEnvironmentFactors.length;
    }

    onSelectAllEnvironmentFactors() {
        if (this.isAllEnvironmentFactorSelected()) {
            this.selectedEnvironmentFactors = [];
        } else {
            this.selectedEnvironmentFactors = [];
            this.environmentFactors.forEach((factor) => this.selectedEnvironmentFactors.push(factor.instanceId));
        }
    }

    isAllTraitsSelected() {
        return this.traits.length > 0 && this.selectedTraits.length === this.traits.length;
    }

    isAllCovariatesSelected() {
        return this.covariates.length > 0 && this.covariates.length === this.selectedCovariates.length;
    }

    onSelectAllTraits() {
        if (this.isAllTraitsSelected()) {
            this.selectedTraits = [];
        } else {
            this.selectedTraits = [];
            this.traits.forEach((variable) => this.selectedTraits.push(variable.termId));
            this.selectedCovariates = [];
        }
    }

    onSelectAllCovariates() {
        if (this.isAllCovariatesSelected()) {
            this.selectedCovariates = [];
        } else {
            this.selectedCovariates = [];
            this.covariates.forEach((variable) => this.selectedCovariates.push(variable.termId));
        }
    }

    loadStudy(study) {
        this.resetVariables();
        this.context.studyId = study.id;
        this.studyService.getStudyDetails(study.id).subscribe(
            (res: HttpResponse<StudyDetails>) => this.study = res.body
        );

        this.datasetService.getDatasets(study.id, null).subscribe(
            (res: HttpResponse<DatasetModel[]>) => {
                const plotDataset = res.body.filter((dataset: DatasetModel) => dataset.datasetTypeId === DatasetTypeEnum.PLOT)[0];
                this.environmentDataset = res.body.filter((dataset: DatasetModel) => dataset.datasetTypeId === DatasetTypeEnum.ENVIRONMENT)[0];
                this.environmentDatasetId = this.environmentDataset.datasetId;
                this.plotDatasetName = plotDataset.datasetName;
                this.analysisName = 'SSA analysis of ' + this.plotDatasetName + '  (run at ' + this.datePipe.transform(new Date(), 'yyyy-MM-dd_HH:mm' ) + ')';
                this.plotDatasetId = plotDataset.datasetId;
                this.getPlotDatasetVariables();
            }
        );
    }

    uploadData($event) {
        $event.preventDefault();
        const studyTreeComponent = this.modalService.open(StudyManagerTreeComponent, { modalDialogClass: 'modal-md', backdrop: 'static' });
        studyTreeComponent.componentInstance.hideViewSummaryButton = true;
        studyTreeComponent.result.then((studies) => {
            if (studies && studies.length === 1) {
                this.loadStudy(studies[0]);
                this.context.studyId = studies[0].id;
                const confirmModalRef = this.modalService.open(SingleSiteAnalysisImportComponent as Component, { size: 'lg', backdrop: 'static' });
                confirmModalRef.result.then(() => {
                    this.activeModal.close();
                }, () => this.activeModal.dismiss());
            }
            this.activeModal.close();
        }, () => {
        });
    }

    getPlotDatasetVariables() {
        this.datasetService.getObservationSetColumns(this.context.studyId, this.plotDatasetId).subscribe(
            (res: HttpResponse<ObservationVariable[]>) => {
                res.body.forEach((variable: ObservationVariable) => {
                    if (variable.variableType?.toString() !== VariableTypeEnum[VariableTypeEnum.TRAIT]
                        && variable.variableType?.toString() !== VariableTypeEnum[VariableTypeEnum.SELECTION_METHOD]) {
                        this.germplasmDescriptors.push(variable);
                    } else {
                        this.traits.push(variable);
                        this.covariates.push(variable);
                        if (variable.dataType !== DataTypeEnum.CHARACTER) {
                            this.selectedTraits.push(variable.termId);
                        }
                    }
                });
                this.plotDatasetVariables = res.body;
            }
        );
    }

    back($event) {
        this.isBrowseStudyScreen = true;
    }

    download($event) {
        if (this.validate()) {
            this.isLoading = true;
            const input = new SingleSiteAnalysisInputModel();
            input.studyId = this.study.id;
            input.selectedTraitIds = this.selectedTraits;
            input.selectedCovariateIds = this.selectedCovariates;
            input.instanceIds = this.selectedEnvironmentFactors;
            input.environmentFactor = this.selectedEnvironmentFactor.termId;
            input.breedingViewAnalysisName = this.analysisName;
            input.designTypeId = this.selectedExptDesignType.termId;
            input.blockFactor = this.selectedIncompleteBlockFactor ? this.selectedIncompleteBlockFactor.termId : null;
            input.replicatesFactor = this.selectedRepFactor ? this.selectedRepFactor.termId : null;
            input.columnFactor = this.selectedColFactor ? this.selectedColFactor.termId : null;
            input.rowFactor = this.selectedRowFactor ? this.selectedRowFactor.termId : null;
            input.genotypesFactor = this.selectedGenotype ? this.selectedGenotype.termId : null;
            this.singleSiteAnalysisService.download(this.study.id, input).pipe(finalize(() => {
                this.isLoading = false;
            })).toPromise().then((response: any) => {
                const fileName = this.fileDownloadHelper.getFileNameFromResponseContentDisposition(response);
                this.fileDownloadHelper.save(response.body, fileName);

            });
        }
    }

    private validate(): boolean {
        if (!this.selectedEnvironmentFactor) {
            this.alertService.error('single-site-analysis.validation.environment.factor.required');
            return false;
        }
        if (!this.selectedEnvironmentFactors || this.selectedEnvironmentFactors.length === 0) {
            this.alertService.error('single-site-analysis.validation.environment.required');
            return false;
        }
        if (this.selectedEnvironmentFactor.termId !== this.TRIAL_INSTANCE) {
            const selectedEnvironmentFactorModels = this.environmentFactors.filter((factor) => this.selectedEnvironmentFactors.find((item) => item === factor.instanceId));
            const environmentFactorValues = [];
            selectedEnvironmentFactorModels.forEach((factor) => environmentFactorValues.push(factor.idValueMap[this.selectedEnvironmentFactor.termId]));
            if ((new Set(environmentFactorValues)).size !== environmentFactorValues.length) {
                this.alertService.error('single-site-analysis.validation.environment.factor.duplicate');
                return false;
            }
        }
        if (!this.selectedExptDesignType) {
            this.alertService.error('single-site-analysis.validation.design.type.required');
            return false;
        }
        if (this.selectedExptDesignType === ExperimentalDesignTypeEnum.RANDOMIZED_COMPLETE_BLOCK && !this.selectedRepFactor) {
            this.alertService.error('single-site-analysis.validation.replicates.factor.required');
            return false;
        }
        if (this.isIncompleteBlockFactorRequired() && !this.selectedIncompleteBlockFactor) {
            this.alertService.error('single-site-analysis.validation.incomplete.block.factor.required');
            return false;
        }
        if (this.selectedExptDesignType === ExperimentalDesignTypeEnum.ROW_COL && !this.selectedRowFactor) {
            this.alertService.error('single-site-analysis.validation.row.factor.required');
            return false;
        }
        if (this.selectedExptDesignType === ExperimentalDesignTypeEnum.ROW_COL && !this.selectedColFactor) {
            this.alertService.error('single-site-analysis.validation.col.factor.required');
            return false;
        }
        if ((!this.selectedColFactor && this.selectedRowFactor) || (this.selectedColFactor && !this.selectedRowFactor)) {
            this.alertService.error('single-site-analysis.validation.row.col.factors.required');
            return false;
        }
        if (!this.selectedGenotype) {
            this.alertService.error('single-site-analysis.validation.genotypes.factor.required');
            return false;
        }
        return true;
    }

    isIncompleteBlockFactorRequired(): boolean {
        return this.selectedExptDesignType === ExperimentalDesignTypeEnum.RESOLVABLE_INCOMPLETE_BLOCK
            || this.selectedExptDesignType === ExperimentalDesignTypeEnum.P_REP;
    }

    upload($event) {
    }

    cancel($event) {
        this.resetVariables();
    }

    resetVariables() {
        this.study = null;
        this.plotDatasetName = null;
        this.plotDatasetId = null;
        this.environmentDatasetId = null;
        this.plotDatasetVariables = [];
        this.germplasmDescriptors = [];
        this.traits = [];
        this.covariates = [];
        this.selectedTraits = [];
        this.selectedCovariates = [];
        this.selectedEnvironmentFactors = [];
        this.isLoading = false;
        this.isBrowseStudyScreen = true;
        this.analysisName = null;
        this.environmentVariables = [];
        this.selectedEnvironmentFactor = null;
        this.repFactors = [];
        this.selectedRepFactor = null;
        this.incompleteBlockFactors = [];
        this.selectedIncompleteBlockFactor = null;
        this.rowFactors = [];
        this.selectedRowFactor = null;
        this.colFactors = [];
        this.selectedColFactor = null;
        this.genotypeVariables = [];
        this.selectedGenotype = null;
        this.environmentFactors = [];
        this.selectedExptDesignType  = null;
        this.studyExptDesign = null;
    }

    continue($event) {
        this.isBrowseStudyScreen = false;
        this.checkForCategoricalTraits();
        this.getEnvironmentFactors();
        this.populateRepFactors();
        this.populateIncompleteBlockFactors();
        this.populateRowFactors();
        this.populateColFactors();
        this.populateGenotypes();
    }

    checkForCategoricalTraits() {
        const categoricalSelectedTraits = this.traits.filter((trait) =>
            this.selectedTraits.find((item) => item === trait.termId) && trait.dataType === DataTypeEnum.CATEGORICAL);
        if (categoricalSelectedTraits && categoricalSelectedTraits.length > 0) {
            this.alertService.warning('single-site-analysis.validation.categorical.warning');
        }
    }

    getEnvironmentFactors() {
        this.datasetService.getObservationSetColumns(this.context.studyId, this.environmentDatasetId).subscribe(
            (res) => {
                this.environmentVariables = res.body
                    .filter((variable: ObservationVariable) => variable.variableType?.toString() === VariableTypeEnum[VariableTypeEnum.ENVIRONMENT_DETAIL]);
                const request = new ObservationUnitsSearchRequest();
                request.environmentDetails = this.environmentVariables;
                request.instanceIds = this.getInstanceIdsWithExperimentalDesign();
                this.datasetService.getObservationUnitTable(this.context.studyId, this.environmentDatasetId, request, null).subscribe(
                    (result) => {
                        this.environmentFactors = [];
                        result.body.forEach((observation: ObservationUnitsSearchResponse) => {
                            const environmentFactorModel = new EnvironmentFactorModel();
                            environmentFactorModel.trialInstance = observation.trialInstance;
                            environmentFactorModel.idValueMap = {};
                            this.environmentVariables.forEach((environmentVariable) => {
                                if (environmentVariable.termId !== TermIdEnum.TRIAL_INSTANCE) {
                                    if (environmentVariable.termId === TermIdEnum.LOCATION_ID) {
                                        environmentFactorModel.idValueMap[environmentVariable.termId] = observation.variables['LOCATION_ID'].value;
                                    } else if (environmentVariable.possibleValues && environmentVariable.possibleValues.length > 0) {
                                        const categoricalIdValue = this.getValue(environmentVariable.name, observation);
                                        environmentFactorModel.idValueMap[environmentVariable.termId] = categoricalIdValue;
                                        environmentVariable.possibleValues.forEach((valueRef) => {
                                            if (valueRef.id.toString() === categoricalIdValue) {
                                                environmentFactorModel.idValueMap[environmentVariable.termId] = valueRef.name;
                                            }
                                        });
                                    } else {
                                        environmentFactorModel.idValueMap[environmentVariable.termId] = this.getValue(environmentVariable.name, observation);
                                    }
                                }
                                if (!this.selectedExptDesignType && TermIdEnum.EXPT_DESIGN === environmentVariable.termId) {
                                    this.selectedExptDesignType = this.ExperimentalDesignTypeMap.get(parseInt(observation.environmentVariables[environmentVariable.name].value, 10));
                                }
                            });
                            environmentFactorModel.instanceId = this.instanceNumberIdMap[environmentFactorModel.trialInstance];
                            this.environmentFactors.push(environmentFactorModel);
                        });
                        this.validateEnvironmentFactors(request.instanceIds);
                    }
                );
            }
        );
    }

    validateEnvironmentFactors(instanceIds) {
        const validEnvironmentPromise = this.singleSiteAnalysisService.getEnvironmentIdsValidForSSA(this.study.id, this.plotDatasetId).toPromise();
        validEnvironmentPromise.then((validEnvironmentIds) => {
            this.invalidEnvironmentFactorIds = instanceIds.filter((x) => !validEnvironmentIds.includes(x));
            if (this.invalidEnvironmentFactorIds.length > 0) {
                const invalidTrialInstances = [];
                this.environmentFactors.forEach((instance) => {
                    if (this.invalidEnvironmentFactorIds.includes(instance.instanceId)) {
                        invalidTrialInstances.push(instance.trialInstance);
                    }
                });
                this.alertService.warning('single-site-analysis.validation.incomplete.data', { param: invalidTrialInstances.join(', ') });
            }
        });
    }

    getInstanceIdsWithExperimentalDesign() {
        const instanceIds = [];
        this.environmentDataset.instances.forEach((instance) => {
            if (instance.hasExperimentalDesign) {
                this.instanceNumberIdMap[instance.instanceNumber] = instance.instanceId;
                instanceIds.push(instance.instanceId);
            }
        });
        return instanceIds;
    }

    getValue(key: string, observation: ObservationUnitsSearchResponse): string {
        return observation.environmentVariables[key] ? observation.environmentVariables[key].value : null;
    }

    populateRepFactors() {
        this.repFactors = this.plotDatasetVariables.filter((variable) => variable.property && variable.property.toLowerCase() === 'replication factor');
        if (this.repFactors.length > 0) {
            this.selectedRepFactor = this.repFactors[0];
        }
    }

    populateIncompleteBlockFactors() {
        this.incompleteBlockFactors = this.plotDatasetVariables.filter((variable) => variable.property && variable.property.toLowerCase() === 'blocking factor');
        if (this.incompleteBlockFactors.length > 0) {
            this.selectedIncompleteBlockFactor = this.incompleteBlockFactors[0];
        }
    }

    populateRowFactors() {
        this.rowFactors = this.plotDatasetVariables.filter((variable) => variable.property && variable.property.toLowerCase() === 'row in layout');
        if (this.rowFactors.length > 0) {
            this.selectedRowFactor = this.rowFactors[0];
        }
    }

    populateColFactors() {
        this.colFactors = this.plotDatasetVariables.filter((variable) => variable.property && variable.property.toLowerCase() === 'column in layout');
        if (this.colFactors.length > 0) {
            this.selectedColFactor = this.colFactors[0];
        }
    }

    populateGenotypes() {
        this.genotypeVariables = this.plotDatasetVariables.filter((variable) => {
            if (variable.termId === TermIdEnum.GID) {
                this.selectedGenotype = variable;
            }
            return  variable.variableType?.toString() === VariableTypeEnum[VariableTypeEnum.GERMPLASM_DESCRIPTOR] || variable.termId === TermIdEnum.ENTRY_NO;
        });
        if (this.genotypeVariables.length > 0 && this.selectedGenotype === null) {
            this.selectedGenotype = this.genotypeVariables[0];
        }
    }

    showReplicatesFactorDropDown() {
        return this.selectedExptDesignType
            && this.selectedExptDesignType !== ExperimentalDesignTypeEnum.P_REP
            && this.selectedExptDesignType !== ExperimentalDesignTypeEnum.AUGMENTED_RANDOMIZED_BLOCK;
    }

    showIncompleteBlockFactorDropDown() {
        return this.selectedExptDesignType
            && this.selectedExptDesignType !== ExperimentalDesignTypeEnum.RANDOMIZED_COMPLETE_BLOCK
            && this.selectedExptDesignType !== ExperimentalDesignTypeEnum.ROW_COL;
    }

    isExptDesignRowCol() {
        return this.selectedExptDesignType && this.selectedExptDesignType === ExperimentalDesignTypeEnum.ROW_COL;
    }

    disableContinueButton() {
        return this.selectedTraits.length === 0;
    }

}
